import { usePageEventDispatcher } from "@octopusdeploy/portal-routes";
import React from "react";
import { createResourceTypeField } from "~/analytics/fields";
export function useNotifyGitConnectionEvent() {
    const dispatcher = usePageEventDispatcher();
    return React.useCallback((name: string) => dispatcher(name, {
        ...createResourceTypeField("GitHub Connection"),
    }), [dispatcher]);
}
